import { useEffect, useState } from "react";
import {
  canInstallPwa,
  detectInstallPlatform,
  subscribePwaInstall,
  wasPwaInstalled,
} from "../utils/pwaInstall";

export function usePwaInstall() {
  const [canInstall, setCanInstall] = useState(canInstallPwa);
  const [isInstalled, setIsInstalled] = useState(wasPwaInstalled);
  const [platform] = useState(detectInstallPlatform);

  useEffect(
    () =>
      subscribePwaInstall(() => {
        setCanInstall(canInstallPwa());
        setIsInstalled(wasPwaInstalled());
      }),
    []
  );

  return { canInstall, isInstalled, platform };
}
